import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const PassengerIcon: FC<IconProps> = ({ width = 16, height = 30, ...rest }) => (
  <Icon type="Passenger" width={width} height={height} alt="PassengerIcon" {...rest} />
)
